var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5781 15C14.235 15 15.5781 13.6569 15.5781 12C15.5781 10.3431 14.235 9 12.5781 9C10.9213 9 9.57812 10.3431 9.57812 12C9.57812 13.6569 10.9213 15 12.5781 15Z",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57812 12.8804V11.1204C2.57812 10.0804 3.42813 9.22043 4.47813 9.22043C6.28813 9.22043 7.02812 7.94042 6.11812 6.37042C5.59812 5.47042 5.90812 4.30042 6.81812 3.78042L8.54812 2.79042C9.33812 2.32042 10.3581 2.60042 10.8281 3.39042L10.9381 3.58042C11.8381 5.15042 13.3181 5.15042 14.2281 3.58042L14.3381 3.39042C14.8081 2.60042 15.8281 2.32042 16.6181 2.79042L18.3481 3.78042C19.2581 4.30042 19.5681 5.47042 19.0481 6.37042C18.1381 7.94042 18.8781 9.22043 20.6881 9.22043C21.7281 9.22043 22.5881 10.0704 22.5881 11.1204V12.8804C22.5881 13.9204 21.7381 14.7804 20.6881 14.7804C18.8781 14.7804 18.1381 16.0604 19.0481 17.6304C19.5681 18.5404 19.2581 19.7004 18.3481 20.2204L16.6181 21.2104C15.8281 21.6804 14.8081 21.4004 14.3381 20.6104L14.2281 20.4204C13.3281 18.8504 11.8481 18.8504 10.9381 20.4204L10.8281 20.6104C10.3581 21.4004 9.33812 21.6804 8.54812 21.2104L6.81812 20.2204C5.90812 19.7004 5.59812 18.5304 6.11812 17.6304C7.02812 16.0604 6.28813 14.7804 4.47813 14.7804C3.42813 14.7804 2.57812 13.9204 2.57812 12.8804Z",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsSvg);
export default __webpack_public_path__ + "static/media/settings_svg.acde1a136469d82be65d6a4c01ff6a36.svg";
export { ForwardRef as ReactComponent };